// src/components/HealthVitalsReport.js

import React from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

export default function HealthVitalsReport({ healthVitals = [] }) {
  if (!healthVitals || healthVitals.length === 0) return null;

  return (
    <Box className="vitals-report-container" sx={{ my: 1 }}>
      <Typography variant="subtitle1" gutterBottom>
        Health Vitals Report
      </Typography>
      <TableContainer component={Paper} className="vitals-table">
        <Table>
          <TableHead>
            <TableRow sx={{ height: "28px" }}>
              <TableCell
                sx={{
                  fontWeight: "bold",
                  fontSize: "0.72rem",
                  background: "#1976d2",
                  color: "#fff",
                  padding: "4px",
                }}
              >
                <Box display="flex" justifyContent="space-between">
                  <span>NAME</span>
                  <span>RANGE</span>
                </Box>
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  fontWeight: "bold",
                  fontSize: "0.72rem",
                  background: "#1976d2",
                  color: "#fff",
                }}
              >
                CURRENT
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  fontWeight: "bold",
                  fontSize: "0.72rem",
                  background: "#1976d2",
                  color: "#fff",
                }}
              >
                RESULT
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {healthVitals
              .filter((vital) => vital.active === 1)
              .map((vital, idx) => (
                <TableRow
                  key={vital.slug}
                  sx={{
                    height: "24px",
                    backgroundColor:
                      idx % 2 === 0 ? "background.paper" : "#f9f9f9",
                  }}
                >
                  <TableCell
                    className="uppercase"
                    sx={{
                      fontSize: "0.72rem",
                      padding: "4px",
                    }}
                  >
                    <Box display="flex" justifyContent="space-between">
                      <span style={{ textTransform: "uppercase" }}>
                        {vital.slug}
                      </span>
                      <span>
                        {vital.min} - {vital.max}
                      </span>
                    </Box>
                  </TableCell>
                  <TableCell align="center" sx={{ fontSize: "0.72rem" }}>
                    <span
                      style={{
                        color: vital.result === "N" ? "#d32f2f" : "inherit",
                        fontWeight: vital.result === "N" ? "bold" : "normal",
                      }}
                    >
                      {vital.current}
                    </span>
                  </TableCell>
                  <TableCell align="center" sx={{ fontSize: "0.72rem" }}>
                    <span
                      style={{
                        color: vital.result === "N" ? "#d32f2f" : "#388e3c",
                        fontWeight: "bold",
                      }}
                    >
                      {vital.result === "N" ? "Fail" : "Pass"}
                    </span>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
